/**
 * APP_MODE values:
 *   PUBLIC  - only /app and /int routes (no login required)
 *   PRIVATE - only /cb routes (login required)
 *   BOTH    - all routes accessible; used in test environments (dev, stg, uat, partner/ppr)
 */
const APP_MODE = process.env.VUE_APP_MODE;

export const isPrivateMode = () => APP_MODE === 'PRIVATE' || APP_MODE === 'BOTH';
export const isPublicMode = () => APP_MODE === 'PUBLIC' || APP_MODE === 'BOTH';
export const isBothMode = () => APP_MODE === 'BOTH';

/**
 * Returns the subscriber path suffix used in API routes.
 * PRIVATE always uses /subscriber.
 * BOTH is dynamic: only uses /subscriber when the current path is under /cb.
 */
export const getSubscriberSuffix = () => {
  if (APP_MODE === 'PRIVATE') return '/subscriber';
  if (APP_MODE === 'BOTH') return window.location.pathname.startsWith('/cb') ? '/subscriber' : '';
  return '';
};
